module.exports = __webpack_public_path__ + "static/media/jaune.e652054f.png";